import { IOnboardingTour } from 'codex-lib';

const SORT_ORDER_TOUR_ACTIVE_CLASS = 'sort-order-tour-active';
const SORT_ORDER_TOUR_BACK_TEXT = 'onboardings.sortOrder.btnPrev';
const SORT_ORDER_TOUR_EXIT_TEXT = 'onboardings.sortOrder.btnExit';

export function openDropdownForTour(
  dropdownComponent: any,
  hostElement?: HTMLElement,
  menuClass?: string
): boolean {
  const ngbDropdown = dropdownComponent?.mydrop;
  const toggleButton = hostElement?.querySelector('.main-dropdown-btn, button') as HTMLButtonElement;

  let openMenu = getOpenDropdownMenu();
  if (openMenu) {
    addMenuClass(openMenu, menuClass);
    return true;
  }

  toggleButton?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  dropdownComponent?.onToggle?.(true);

  openMenu = getOpenDropdownMenu();
  if (!openMenu) {
    ngbDropdown?.open?.();
    dropdownComponent?.onToggle?.(true);
    openMenu = getOpenDropdownMenu();
  }

  addMenuClass(openMenu, menuClass);
  return !!openMenu;
}

export function closeDropdownForTour(dropdownComponent: any): void {
  const ngbDropdown = dropdownComponent?.mydrop;
  ngbDropdown?.close?.();
}

export function enableSortOrderTourLayer(): void {
  document.body.classList.add(SORT_ORDER_TOUR_ACTIVE_CLASS);
}

export function disableSortOrderTourLayer(): void {
  document.body.classList.remove(SORT_ORDER_TOUR_ACTIVE_CLASS);
}

export function setSortOrderTourPrevButtonAsBack(tour: IOnboardingTour): void {
  tour.actionButtons.prev.text = SORT_ORDER_TOUR_BACK_TEXT;
}

export function setSortOrderTourPrevButtonAsExit(tour: IOnboardingTour): void {
  tour.actionButtons.prev.text = SORT_ORDER_TOUR_EXIT_TEXT;
}

export function createSortOrderTour(
  selector: string,
  title: string,
  description: string,
  optionsSelector: string,
  optionsTitle: string,
  optionsDescription: string
): IOnboardingTour {
  return {
    steps: [
      {
        title,
        description,
        element: {
          selector
        }
      },
      {
        title: optionsTitle,
        description: optionsDescription,
        element: {
          selector: optionsSelector
        }
      }
    ],
    actionButtons: {
      prev: {
        text: SORT_ORDER_TOUR_EXIT_TEXT
      },
      next: {
        text: 'onboardings.sortOrder.btnNext',
        textComplete: 'onboardings.sortOrder.btnComplete'
      }
    },
    counter: {
      showCounter: true,
      textOf: 'onboardings.sortOrder.counterOf'
    }
  };
}

function getOpenDropdownMenu(): HTMLElement | null {
  const openMenus = Array.from(document.querySelectorAll('.newDropdown.show, .dropdown-menu.show')) as HTMLElement[];
  return openMenus.length > 0 ? openMenus[openMenus.length - 1] : null;
}

function addMenuClass(menu: HTMLElement | null, menuClass?: string): void {
  if (menu && menuClass) {
    menu.classList.add(menuClass);
  }
}
